// Don't export from index.ts. That will cause any component using feature flags to then also pull this whole component.
export const toggleFeatureEvent = 'FeatureFlagManager_FeatureFlagSwitch.toggleFeature';
//# sourceMappingURL=consts.js.map